var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is_responsive)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:_vm._class},[_vm._t("default")],2)]):_c('table',{staticClass:"table",class:_vm._class},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }